import type { AxiosResponse } from 'axios'
import { call, delay, select, takeLatest } from 'redux-saga/effects'

import { getActiveCompanyId, getErrorMessage } from '@helpers'

import { TYPING_INTERVAL } from '@constants'

import actions from './actions'
import * as api from './api'

function* fetchReportsSaga({ meta: { resolve, reject } }: AsyncSagaAction<void>) {
  try {
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.fetchReports, companyId)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error)
    yield call(reject, errorMsg)
  }
}

function* fetchOnboardingTasksSaga({ meta: { resolve, reject } }: AsyncSagaAction<void>) {
  try {
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.fetchOnboardingTasks, companyId)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error)
    yield call(reject, errorMsg)
  }
}

function* fetchVatPositionReportSaga({ meta: { resolve, reject } }: AsyncSagaAction<void>) {
  try {
    yield delay(TYPING_INTERVAL)
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.fetchVatPositionReport, companyId)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error)
    yield call(reject, errorMsg)
  }
}

function* fetchBankTransactionsReportSaga({ meta: { resolve, reject } }: AsyncSagaAction<void>) {
  try {
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.fetchBankTransactionsReport, companyId)
    yield call(resolve, response.data)
  } catch (error) {
    const errorMsg = getErrorMessage(error)
    yield call(reject, errorMsg)
  }
}

// watcher Saga
export default function* commonSaga() {
  yield takeLatest(actions.fetchReports.REQUEST, fetchReportsSaga)
  yield takeLatest(actions.fetchOnboardingTasks.REQUEST, fetchOnboardingTasksSaga)
  yield takeLatest(actions.fetchVatPositionReport.REQUEST, fetchVatPositionReportSaga)
  yield takeLatest(actions.fetchBankTransactionsReport.REQUEST, fetchBankTransactionsReportSaga)
}
